var $ = require('jquery');

$(function () {
    if ($('._1900_202_InteractiveContentColumnCarousel').length > 0) {
        var isPageEditor = window.SitecoreUtilities.isPageEditor;

        if (!isPageEditor()) {
            var slider = $('._1900_202_InteractiveContentColumnCarousel__carousel');

            $(slider).each(function() {
                var maxRows = $(this).attr("data-maxRows").toString();
                var getMaxRowValue = JSON.parse(maxRows);

                $(this).slick({
                    arrows: false,
                    infinite: true,
                    slidesToScroll: 1,
                    centerMode: false,
                    centerPadding: '60px',
                    variableWidth: false,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: (getMaxRowValue == 1) ? 1 : 2
                            }
                        }
                    ],
                    rtl: window.GenericUtilities.isRTL()
                });
            });

            $(window).on('resize orientationchange', function () {
                slider.slick('resize');
            });

            // to get slick slider to initialize on screen resize
            // https://github.com/kenwheeler/slick/issues/1730


            slider.on('afterChange',
                function(event, slick, currentSlide) {
                    //need fuction to stop automatic slide after clicked
                    $('.autoplay').slick('slickPause');
            });
        }
    }
});